import { z } from 'zod';
import { DEFAULT_LIMITS, DEFAULT_PAGE_SIZE } from '#src/rsql/index.js';
export { DEFAULT_PAGE_SIZE };
/**
 * Limite de segurança: nenhuma rota devolve mais itens que isto por página.
 * O mesmo das listagens RSQL, para as duas não divergirem.
 */
export const MAX_PAGE_SIZE = DEFAULT_LIMITS.maxPageSize;
/**
 * Só página, sem filtro: para listas compiladas em memória (os chamados de uma
 * pessoa). Recursos que viram tabela usam `listQuerySchema` de `rsql`.
 */
export const pageQuerySchema = z.strictObject({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce
        .number()
        .int()
        .min(1)
        .max(MAX_PAGE_SIZE)
        .default(DEFAULT_PAGE_SIZE),
});
/** Envelope de uma página de `item`. */
export const pageOf = (item) => z.strictObject({
    items: z.array(item),
    page: z.int().min(1),
    pageSize: z.int().min(1).max(MAX_PAGE_SIZE),
    totalItems: z.int().nonnegative(),
    totalPages: z.int().nonnegative(),
});
//# sourceMappingURL=pagination.contract.js.map